<template>
    <Container icon="images/papsi_error_icon.svg">
        <div class="w-full h-full flex bg-theme-primary">
            <span v-text="'PAGE NOT FOUND'" class="text-7xl m-auto text-theme-secondary font-bold"/>
        </div>
    </Container>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import mixin from "@/mixin";
import Container from "@/components/sections/ContainerView.vue";

export default defineComponent({
    components: {
        Container,
    },
    mixins: [
        mixin,
    ],
});
</script>